import { CARRIERS } from "@/data/content";

export default function Marquee() {
  const items = [...CARRIERS, ...CARRIERS];
  return (
    <section className="bg-brand-sand/40 border-y border-brand-line py-6 overflow-hidden" data-testid="carrier-marquee">
      <div className="flex items-center gap-3 mb-4 px-5 sm:px-8 max-w-7xl mx-auto">
        <span className="overline">Trusted carrier partners</span>
        <span className="h-px flex-1 bg-brand-line" />
      </div>
      <div className="relative flex overflow-hidden">
        <div className="flex shrink-0 animate-marquee items-center gap-14 pr-14">
          {items.map((c, i) => (
            <span key={i} className="font-serif text-2xl sm:text-3xl text-brand-green/70 whitespace-nowrap italic">
              {c}
            </span>
          ))}
        </div>
        <div className="flex shrink-0 animate-marquee items-center gap-14 pr-14" aria-hidden="true">
          {items.map((c, i) => (
            <span key={`b${i}`} className="font-serif text-2xl sm:text-3xl text-brand-green/70 whitespace-nowrap italic">
              {c}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
